export default [
  {
    thumbnail: "/portfolio/videos/serp/LakesCanada_tn.png",
    source: "/portfolio/videos/serp/LakesCanada.mov",
    caption: "Lakes Canada"
  },
  {
    thumbnail: "/portfolio/videos/serp/News_tn.png",
    source: "/portfolio/videos/serp/News.mov",
    caption: "News"
  },
  {
    thumbnail: "/portfolio/videos/serp/TimBerners_tn.png",
    source: "/portfolio/videos/serp/TimBerners.mov",
    caption: "Tim Berners"
  },
  {
    thumbnail: "/portfolio/videos/serp/WeatherMunich_tn.png",
    source: "/portfolio/videos/serp/WeatherMunich.mov",
    caption: "Weather Munich"
  },
  {
    thumbnail: "/portfolio/videos/serp/Comparison_tn.png",
    source: "/portfolio/videos/serp/Comparison.mp4",
    caption: "Compare performance"
  },
];
